require('../../../components/shared/firebase/leaguestatFirebaseService');

angular.module('app.player.boxscoreController', ['leaguestatFirebaseService'])
	.controller('app.player.boxscoreController', [
	'$scope',
	'$http',
	'$timeout',
	'app.shared.singleGameService',
	'LEAGUESTAT_API',
	'FIREBASE_CREDS',
	'leaguestatFirebaseService',
	'$rootScope',
	function ($scope, $http, $timeout, singleGame, lsapi, fbCreds, lsFb, $rootScope) {
		$scope.leaguestatGame = true;
		$scope.gameSummary;
		let gsUrl = "";
		let timerRunning = false;

		let fbGoalSummary;
		let fbShotSummary;
		let fbPenaltySummary;
		let fbPenalties;
		let fbScoring;

		$scope.spoiled = false;
		$scope.$on('enableGameSpoiler', function(event, data) {
			$scope.spoiled = data;
		});

		let getLsGameSummary = function() {
			return $http.jsonp(gsUrl, {jsonpCallbackParam: 'callback'});
		};

		// This will be called to refresh the lineup stats after we
		// get firebase data for a goal or penalty. We need to provide
		// a bit of a timeout/buffer for stat update to finish on LS.
		let queueGameSummaryRefresh = function() {
			if (!timerRunning) {
				timerRunning = true;
				setTimeout(function() {
							getLsGameSummary().then(function (response) {
								populateGameSummary(response.data);
								timerRunning = false;
							})}, 90000);
			}
		};

		let init = function () {
			if (singleGame.data) {
				let lsClientCode = singleGame.data.league.strleaguestatclientcode;
				let lsGameId = singleGame.data.iscoringprovidergameid;

				// Verify this is a leaguestat game
				if (singleGame.data.iscoringproviderid_fk !== 5 && singleGame.data.iscoringproviderid_fk !== 7) {
					return;
				}

				$scope.language = "en";
				$scope.langId = 1;

				// Set Game Summary URL and load data
				gsUrl = lsapi.clusterUrl + '/feed/index.php?feed=statviewfeed&view=gameSummary' +
					'&game_id=' + lsGameId +
					'&key=' + lsapi.clusterKey +
					'&client_code=' + lsClientCode +
					'&lang=' + $scope.language;

				getLsGameSummary().then(function (response) {
					if (!response.data) {
						$scope.gameSummary = null;
						return;
					}

					populateGameSummary(response.data);

					lsFb.authenticate(fbCreds.leaguestat.firebaseUrl, fbCreds.leaguestat.firebaseApiKey, fbCreds.leaguestat.firebaseToken);

       				// Initialize firebase 
					var updateGoalSummaryWithFbData = function (fbGameGoalSummaryData) {
						if (fbGameGoalSummaryData) {
							fbGoalSummary = fbGameGoalSummaryData;
							updateSummaryWithFbData();
							updateSummaryArea();
						}
					};

					lsFb.subscribeToGameGoalSummary(lsClientCode, lsGameId, $scope.langId, updateGoalSummaryWithFbData);
					$scope.$on('$destroy', function () {
						lsFb.unsubscribeFromGameGoalSummary(lsClientCode, lsGameId, $scope.langId, updateGoalSummaryWithFbData);
					});

					var updatePenaltySummaryWithFbData = function (fbGamePenaltySummaryData) {
						if (fbGamePenaltySummaryData) {
							fbPenaltySummary = fbGamePenaltySummaryData;
							updateSummaryWithFbData();
							updateSummaryArea();
						}
					};

					lsFb.subscribeToGamePenaltySummary(lsClientCode, lsGameId, $scope.langId, updatePenaltySummaryWithFbData);
					$scope.$on('$destroy', function () {
						lsFb.unsubscribeFromGamePenaltySummary(lsClientCode, lsGameId, $scope.langId, updatePenaltySummaryWithFbData);
					});

					var updateShotSummaryWithFbData = function (fbGameShotSummaryData) {
						if (fbGameShotSummaryData) {
							fbShotSummary = fbGameShotSummaryData;
							updateSummaryWithFbData();
							updateSummaryArea();
						}
					};

					lsFb.subscribeToGameShotSummary(lsClientCode, lsGameId, $scope.langId, updateShotSummaryWithFbData);
					$scope.$on('$destroy', function () {
						lsFb.unsubscribeFromGameShotSummary(lsClientCode, lsGameId, $scope.langId, updateShotSummaryWithFbData);
					});

					var updatePenaltiesWithFbData = function (fbPenaltiesData) {
						if (fbPenaltiesData) {
							fbPenalties = fbPenaltiesData.GamePenalties;
							updatePenalties();
							queueGameSummaryRefresh();
						}
					};

					lsFb.subscribeToGamePenalties(lsClientCode, lsGameId, $scope.langId, updatePenaltiesWithFbData);
					$scope.$on('$destroy', function () {
						lsFb.unsubscribeFromGamePenalties(lsClientCode, lsGameId, $scope.langId, updatePenaltiesWithFbData);
					});

					var updateScoringWithFbData = function(fbScoringData) {
						if (fbScoringData) {
							fbScoring = fbScoringData;
							updateScoring();
							queueGameSummaryRefresh();
						}
					};

					lsFb.subscribeToGameScoring(lsClientCode, lsGameId, $scope.langId, updateScoringWithFbData);
						$scope.$on('$destroy', function () {
						lsFb.unsubscribeFromGameScoring(lsClientCode, lsGameId, $scope.langId, updateScoringWithFbData);
					});

					var updateMVPsWithFbData = function(fbMVPData) {
						if (fbMVPData) {
							queueGameSummaryRefresh();
						}
					};

					lsFb.subscribeToGameMVPs(lsClientCode, lsGameId, $scope.langId, updateMVPsWithFbData);
						$scope.$on('$destroy', function () {
						lsFb.unsubscribeFromGameMVPs(lsClientCode, lsGameId, $scope.langId, updateMVPsWithFbData);
					});

				}, function error(response) {
					console.log("Error Status: " +  response.statusText);
				});
			}
      	};

		let populateGameSummary = function(gameData) {
			$scope.gameSummary = gameData;

			// build boxscore tables

			// Scoring
			$scope.scoreSummaryHeadings = [];
			for (let period = 0; period < $scope.gameSummary.periods.length; period++) {
				$scope.scoreSummaryHeadings.push($scope.gameSummary.periods[period].info.shortName);
			}
			if ($scope.gameSummary.hasShootout) $scope.scoreSummaryHeadings.push("SO");
			$scope.scoreSummaryHeadings.push("T");

			// visiting team scoring
			$scope.visitingScoreSummary = [];
			for (let period = 0; period < $scope.gameSummary.periods.length; period++) {
			$scope.visitingScoreSummary.push($scope.gameSummary.periods[period].stats.visitingGoals);
			}
			if ($scope.gameSummary.hasShootout) { // If there was a shootout, we need to artificially insert a goal
				if ($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals) {
					$scope.visitingScoreSummary.push(1);
				}
				else {
					$scope.visitingScoreSummary.push(0);
				}
			}
			$scope.visitingScoreSummary.push($scope.gameSummary.visitingTeam.stats.goals);
			$rootScope.awayGoals = $scope.gameSummary.visitingTeam.stats.goals;

			// home team scoring
			$scope.homeScoreSummary = [];
			for (let period = 0; period < $scope.gameSummary.periods.length; period++) {
				$scope.homeScoreSummary.push($scope.gameSummary.periods[period].stats.homeGoals);
			}
			if ($scope.gameSummary.hasShootout) { // If there was a shootout, we need to artificially insert a goal
				if ($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals) {
					$scope.homeScoreSummary.push(0);
				}
				else {
					$scope.homeScoreSummary.push(1);
				}
			}
			$scope.homeScoreSummary.push($scope.gameSummary.homeTeam.stats.goals);
			$rootScope.homeGoals = $scope.gameSummary.homeTeam.stats.goals;

			// Create Shots box info
			// headers
			$scope.shotSummaryHeadings = [];
			for (let period = 0; period < $scope.gameSummary.periods.length; period++) {
				$scope.shotSummaryHeadings.push($scope.gameSummary.periods[period].info.shortName);
			}
			$scope.shotSummaryHeadings.push("T");
			// visiting shots
			$scope.visitingShotSummary = [];
			for (let period = 0; period < $scope.gameSummary.periods.length; period++) {
				$scope.visitingShotSummary.push($scope.gameSummary.periods[period].stats.visitingShots);
			}
			$scope.visitingShotSummary.push($scope.gameSummary.visitingTeam.stats.shots);
			// home shots
			$scope.homeShotSummary = [];
			for (let period = 0; period < $scope.gameSummary.periods.length; period++) {
				$scope.homeShotSummary.push($scope.gameSummary.periods[period].stats.homeShots);
			}
			$scope.homeShotSummary.push($scope.gameSummary.homeTeam.stats.shots);

			for (let period = 0; period < $scope.gameSummary.periods.length; period++) {
				for (let goalIndex = 0; goalIndex < $scope.gameSummary.periods[period].goals.length; goalIndex++) {
					let props = $scope.gameSummary.periods[period].goals[goalIndex].properties;
					let allGoalPropertiesOb = [];
					if (props.isPowerPlay == '1') {
						allGoalPropertiesOb.push("PP");
					}
					if (props.isEmptyNet == '1') {
						allGoalPropertiesOb.push("EN");
					}
					if (props.isShortHanded == '1') {
						allGoalPropertiesOb.push("SH");
					}
					if (props.isPenaltyShot == '1') {
						allGoalPropertiesOb.push("PS");
					}
					$scope.gameSummary.periods[period].goals[goalIndex].properties.allGoalProperties = allGoalPropertiesOb.join(', ');
				}
			}
		}

	
		let updateSummaryWithFbData = function () {
			if ($scope.gameSummary) {
				var svGameId = parseInt($scope.gameSummary.details.id);
				var svGame = $scope.gameSummary;

				$timeout(function () {

					if (fbGoalSummary) {
						// Update total goals for game summary and gameSpolierScore section
						$scope.gameSummary.homeTeam.stats.goals = $rootScope.homeGoals = fbGoalSummary.HomeGoalTotal;
						$scope.gameSummary.visitingTeam.stats.goals = $rootScope.awayGoals = fbGoalSummary.VisitorGoalTotal;

						// Update shootout status
						$scope.gameSummary.hasShootout = fbGoalSummary.Shootout;

						// Update powerplay data
						$scope.gameSummary.homeTeam.stats.powerPlayGoals = fbGoalSummary.HomePowerPlayGoals;
						$scope.gameSummary.visitingTeam.stats.powerPlayGoals = fbGoalSummary.VisitorPowerPlayGoals;
						$scope.gameSummary.homeTeam.stats.powerPlayOpportunities = fbGoalSummary.HomePowerPlayAttempts;
						$scope.gameSummary.visitingTeam.stats.powerPlayOpportunities = fbGoalSummary.VisitorPowerPlayAttempts;

						// Update powerplay data
						$scope.gameSummary.homeTeam.stats.powerPlayGoals = fbGoalSummary.HomePowerPlayGoals;
						$scope.gameSummary.visitingTeam.stats.powerPlayGoals = fbGoalSummary.VisitorPowerPlayGoals;
						$scope.gameSummary.homeTeam.stats.powerPlayOpportunities = fbGoalSummary.HomePowerPlayAttempts;
						$scope.gameSummary.visitingTeam.stats.powerPlayOpportunities = fbGoalSummary.VisitorPowerPlayAttempts;

						// Update goal and assist counts
						$scope.gameSummary.homeTeam.stats.goalCount = fbGoalSummary.HomeGoalTotal;
						$scope.gameSummary.visitingTeam.stats.goalCount = fbGoalSummary.VisitorGoalTotal;
						$scope.gameSummary.homeTeam.stats.assistCount = fbGoalSummary.HomeAssistPoints;
						$scope.gameSummary.visitingTeam.stats.assistCount = fbGoalSummary.VisitorAssistPoints;
					}

					if (fbShotSummary) {
						// Update shot totals
						$scope.gameSummary.homeTeam.stats.shots = fbShotSummary.HomeShotTotal;
						$scope.gameSummary.visitingTeam.stats.shots = fbShotSummary.VisitorShotTotal;
					}

					if (fbPenaltySummary) {
						$scope.gameSummary.homeTeam.stats.infractionCount = fbPenaltySummary.HomeInfractionsTotal;
						$scope.gameSummary.visitingTeam.stats.infractionCount = fbPenaltySummary.VisitorInfractionsTotal;
						$scope.gameSummary.homeTeam.stats.penaltyMinuteCount = fbPenaltySummary.HomePIMTotal;
						$scope.gameSummary.visitingTeam.stats.penaltyMinuteCount = fbPenaltySummary.VisitorPIMTotal;
					}

					// Update period specific data
					if (fbGoalSummary && fbGoalSummary.PeriodsInfo) {

						angular.forEach($scope.gameSummary.periods, function (svPeriod) {
							svPeriod.dirty = true; // Set each period to 'dirty' so we can remove the 'dirty' ones after the FB update
						});

						// Update period specific info
						angular.forEach(fbGoalSummary.PeriodsInfo, function (periodInfo, periodId) {

							if (periodId) { // Needs to be here because sometimes firebase will give back undefined keys (the 'array problem')

								var periodExists = false;

								for (var key in $scope.gameSummary.periods) {
									var gameSummaryPeriodId = parseInt($scope.gameSummary.periods[key].info.id);

									if (parseInt(periodId) === gameSummaryPeriodId) { 
										$scope.gameSummary.periods[key].stats.homeGoals = fbGoalSummary.HomeGoalsByPeriod[periodId].toString();
										$scope.gameSummary.periods[key].stats.visitingGoals = fbGoalSummary.VisitorGoalsByPeriod[periodId].toString();

										if (fbShotSummary && fbShotSummary.PeriodsInfo && fbShotSummary.PeriodsInfo[periodId]) { // Update the shots for this period if they are available
											$scope.gameSummary.periods[key].stats.homeShots = fbShotSummary.HomeShotsByPeriod[periodId].toString();
											$scope.gameSummary.periods[key].stats.visitingShots = fbShotSummary.VisitorShotsByPeriod[periodId].toString();
										}

										$scope.gameSummary.periods[key].dirty = false;
										periodExists = true;
										break;
									}
								}

								if (!periodExists) {

									var newGameDataPeriod = {
										info: {shortName: periodInfo.ShortName, longName: periodInfo.LongName},
										stats: {
											homeGoals: fbGoalSummary.HomeGoalsByPeriod[periodId].toString(),
											visitingGoals: fbGoalSummary.VisitorGoalsByPeriod[periodId].toString()
										},
										goals: [], // TODO: when we want to add Firebase goals, do this here.
										penalties: [] // TODO: when we want to add Firebase penalties, do this here.
									};

									if (fbShotSummary.PeriodInfo && fbShotSummary.PeriodInfo[periodId]) { // Update the shots for this period if they are available
										newGameDataPeriod.stats.homeShots = fbShotSummary.HomeShotsByPeriod[periodId].toString();
										newGameDataPeriod.stats.visitingShots = fbShotSummary.VisitorShotsByPeriod[periodId].toString();
									}

									$scope.gameSummary.periods.push(newGameDataPeriod);
								}
							}

						});

						// Remove all the 'dirty' periods (ie. periods we don't want anymore)
						$scope.gameSummary.periods = $scope.gameSummary.periods.filter(function (svPeriod) {
							return !svPeriod.dirty;
						});
					}
				});
			}
		};


		// Updates the 'summary area' of the game center (ie. scoring summary, shots on goal summary and penalty/points summary)
		let updateSummaryArea = function () {

			// Update goal summary
			if ($scope.gameSummary) {

				$timeout(function () {

					// Create Scoring box info
					// headers
					$scope.scoreSummaryHeadings = [];
					for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
						$scope.scoreSummaryHeadings.push($scope.gameSummary.periods[period].info.shortName);
					}
					if($scope.gameSummary.hasShootout) $scope.scoreSummaryHeadings.push("SO");
						$scope.scoreSummaryHeadings.push("T");

					// visiting team scoring
					$scope.visitingScoreSummary = [];
					for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
						$scope.visitingScoreSummary.push($scope.gameSummary.periods[period].stats.visitingGoals);
					}
					if($scope.gameSummary.hasShootout) { // If there was a shootout, we need to artificially insert a goal
						if($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals){
							$scope.visitingScoreSummary.push(1);
						}
						else{
							$scope.visitingScoreSummary.push(0);
						}
					}
					$scope.visitingScoreSummary.push($scope.gameSummary.visitingTeam.stats.goals);

					// home team scoring
					$scope.homeScoreSummary = [];
					for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
						$scope.homeScoreSummary.push($scope.gameSummary.periods[period].stats.homeGoals);
					}
					if($scope.gameSummary.hasShootout) { // If there was a shootout, we need to artificially insert a goal
						if($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals){
							$scope.homeScoreSummary.push(0);
						}
						else{
							$scope.homeScoreSummary.push(1);
						}
					}
					$scope.homeScoreSummary.push($scope.gameSummary.homeTeam.stats.goals);

					// Update shot summary
					// Create Shots box info
					// headers
					$scope.shotSummaryHeadings = [];
					for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
						$scope.shotSummaryHeadings.push($scope.gameSummary.periods[period].info.shortName);
					}
					$scope.shotSummaryHeadings.push("T");
					// visiting shots
					$scope.visitingShotSummary = [];
					for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
						$scope.visitingShotSummary.push($scope.gameSummary.periods[period].stats.visitingShots);
					}
					$scope.visitingShotSummary.push($scope.gameSummary.visitingTeam.stats.shots);
					// home shots
					$scope.homeShotSummary = [];
					for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
						$scope.homeShotSummary.push($scope.gameSummary.periods[period].stats.homeShots);
					}
					$scope.homeShotSummary.push($scope.gameSummary.homeTeam.stats.shots);

					// Update penalty and points summary


					// Doing this thing... should probably be somewhere else?
					for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
						for (var goalIndex = 0; goalIndex < $scope.gameSummary.periods[period].goals.length; goalIndex++) {
							var props = $scope.gameSummary.periods[period].goals[goalIndex].properties;
							var allGoalPropertiesOb = [];
							if(props.isPowerPlay == '1') {
								allGoalPropertiesOb.push('PP');
							}
							if(props.isEmptyNet == '1') {
								allGoalPropertiesOb.push('EN');
							}
							if(props.isShortHanded == '1') {
								allGoalPropertiesOb.push('SH');
							}
							if(props.isPenaltyShot == '1') {
								allGoalPropertiesOb.push('PS');
							}
							$scope.gameSummary.periods[period].goals[goalIndex].properties.allGoalProperties = allGoalPropertiesOb.join(', ');
						}
					}
				});
			}
		};

		let updateScoring = function () {
			if ($scope.gameSummary && fbScoring) {
				$timeout(function () {

					let newSvGoals = [];

					angular.forEach(fbScoring, function (fbGoal) {
						if (!(fbGoal.Period in newSvGoals)) {
							newSvGoals[fbGoal.Period] = [];
						}

						// goal seconds used for sorting later on
						let timeSplit = fbGoal.Time.split(":");
						let goalSeconds = parseInt(timeSplit[0]) * 60 + parseInt(timeSplit[1]);

						let newSVGoal = {
							period: fbGoal.PeriodLongName,
							periodNum: fbGoal.Period,
							properties: {
								isPowerPlay: fbGoal.PowerPlay,
								isShortHanded: fbGoal.ShortHanded,
								isEmptyNet: fbGoal.EmptyNet,
								isPenaltyShot: fbGoal.PenaltyShot
							},
							time: fbGoal.Time,
							seconds: goalSeconds,
							scoredBy: {
								id: fbGoal.ScorerPlayerId,
								firstName: fbGoal.ScorerPlayerFirstName,
								lastName: fbGoal.ScorerPlayerLastName,
								jerseyNumber: fbGoal.ScorerJerseyNumber
							},
							assists: [],
							plus_players: [],
							minus_players: [],
							team: (fbGoal.IsHome) ? $scope.gameSummary.homeTeam.info : $scope.gameSummary.visitingTeam.info
						};

						// Check for assisting player
						if (fbGoal.Assist1PlayerId > 0) {
							let assistingPlayer = {
								id: fbGoal.Assist1PlayerId,
								firstName: fbGoal.Assist1PlayerFirstName,
								lastName: fbGoal.Assist1PlayerLastName,
								jerseyNumber: fbGoal.Assist1PlayerJerseyNumber
							};

							newSVGoal.assists.push(assistingPlayer);

							// Check for second assisting player
							if (fbGoal.Assist2PlayerId > 0) {
								let assistingPlayer = {
									id: fbGoal.Assist2PlayerId,
									firstName: fbGoal.Assist2PlayerFirstName,
									lastName: fbGoal.Assist2PlayerLastName,
									jerseyNumber: fbGoal.Assist2PlayerJerseyNumber
								};

								newSVGoal.assists.push(assistingPlayer);
							}
						}

						// Check for +/-
						if (fbGoal.PlusPlayers) {
							angular.forEach(fbGoal.PlusPlayers, function(plusPlayer) {
								newSVGoal.plus_players.push({
									id: plusPlayer.Id,
									firstName: plusPlayer.FirstName,
									lastName: plusPlayer.LastName,
									jerseyNumber: plusPlayer.Jersey
								});
							});
						}
						
						if (fbGoal.MinusPlayers) {
							angular.forEach(fbGoal.MinusPlayers, function(minusPlayer) {
								newSVGoal.minus_players.push({
									id: minusPlayer.Id,
									firstName: minusPlayer.FirstName,
									lastName: minusPlayer.LastName,
									jerseyNumber: minusPlayer.Jersey
								});
							});
						}					

						newSvGoals[fbGoal.Period].push(newSVGoal);
					});

					// Assign each array of goals to the proper game summary period goals
					angular.forEach($scope.gameSummary.periods, function(periodSummary) {
						angular.forEach(newSvGoals, function(svPeriodGoals) {
							if (periodSummary.info.id == svPeriodGoals[0].periodNum) {
								periodSummary.goals = svPeriodGoals;
								periodSummary.goals.sort(sortOnAttributes(scoringSortAttrs));								
								return;
							}
						});
					});					
				});
			}
		}

		let updatePenalties = function() {
			if ($scope.gameSummary && fbPenalties) {
				$timeout(function () {

					var newSvPenalties = [];

					angular.forEach(fbPenalties, function (fbPenalty) {
						if (!(fbPenalty.Period in newSvPenalties)) {
							newSvPenalties[fbPenalty.Period] = [];
						}

						// penalty seconds used for sorting later on
						let timeSplit = fbPenalty.Time.split(":");
						let penaltySeconds = parseInt(timeSplit[0]) * 60 + parseInt(timeSplit[1]);

						var newSVPenalty = {
							againstTeam: (fbPenalty.Home) ? $scope.gameSummary.homeTeam.info : $scope.gameSummary.visitingTeam.info,
							description: fbPenalty.OffenceDescription,
							isPowerPlay: fbPenalty.PowerPlay,
							period: {
								id: fbPenalty.Period
							},
							periodNum: fbPenalty.Period,
							seconds: penaltySeconds,
							servedBy: {
								id: fbPenalty.ServedPlayerId,
								firstName: fbPenalty.ServedPlayerFirstName,
								lastName: fbPenalty.ServedPlayerLastName,
								jerseyNumber: fbPenalty.ServedPlayerJerseyNumber
							},
							time: fbPenalty.Time,
							minutes: fbPenalty.Minutes,
							takenBy: {
								id: fbPenalty.PenalizedPlayerId,
								firstName: fbPenalty.PenalizedPlayerFirstName,
								lastName: fbPenalty.PenalizedPlayerLastName,
								jerseyNumber: fbPenalty.PenalizedPlayerJerseyNumber
							}
						};

						newSvPenalties[fbPenalty.Period].push(newSVPenalty);
					});

					// Assign each array of periods to the proper game summary period periods
					angular.forEach($scope.gameSummary.periods, function(periodSummary) {
						angular.forEach(newSvPenalties, function(svPeriodPenalties) {
							if (periodSummary.info.id == svPeriodPenalties[0].period.id) {
								periodSummary.penalties = svPeriodPenalties;
								periodSummary.penalties.sort(sortOnAttributes(scoringSortAttrs));								
								return;
							}
						});
					});					
				});
			}
		}

        let scoringSortAttrs = [{field:'periodNum', direction:'asc'}, {field:'seconds', direction:'asc'}];

        let sortOnAttributes = function(attrs) {
            return function (a,b) {
                for(var i=0; i<attrs.length; i++) {
                    let retval = a[attrs[i].field] < b[attrs[i].field] ? -1 : a[attrs[i].field] > b[attrs[i].field] ? 1 : 0;
                    if (attrs[i].direction == "desc") {
                        retval = retval * -1;
                    }
                    if (retval !== 0) {
                        return retval;
                    }
                }
            }
        };

		$scope.$watch(
			() => {
				return singleGame.data;
			},
			() => {
				init();
			}
		);

		init();
	}
	]).config(['$sceDelegateProvider', 'LEAGUESTAT_API', function ($sceDelegateProvider, LEAGUESTAT_API) {
		$sceDelegateProvider.resourceUrlWhitelist(['self', LEAGUESTAT_API.clusterUrl + '/**']);
	}]);



// WEBPACK FOOTER //
// ./app.v2/components/player/boxscore/boxscoreController.js